<div
  style="width: 100%; height: 18px; border-radius: 27px"
  [ngStyle]="{ background: remainingProgressColor }"
>
  @if (progressPercentage > 0) {
    <div
      style="border-radius: 27px; height: 17px"
      [ngStyle]="{
        background: progressColor,
        color: progressColor,
        width: progressPercentage + '%',
      }"
    >
      {{ progressPercentage }}
    </div>
  }
</div>
<!-- [ngStyle]="{'background':'linear-gradient(to right, '+progressColor+' '+progressPercentage+'%, '+remainingProgressColor+' '+progressPercentage+'%'}" -->
